import { useCallback, useState } from 'react';

import { Checkbox, SubmissionButtons } from '@components/common';

import { useModal } from '@components/common/Modal/utils';

import { IWorkingDays } from '@interfaces/cmModule/operationWindowRules';
import { IIsChecked } from '@interfaces/common/common';
import { TRequiredSelectOption } from '@interfaces/components/componentTypes';

import { operationRulesWeekOptions } from '../constants';

import styles from './OperationWindowRulesDuplicateForm.module.scss';

interface IOperationWindowRulesDuplicateFormProps {
	onSubmit: (selectedDays: string[]) => void;
	disabledDay?: IWorkingDays;
}

const OperationWindowRulesDuplicateForm = ({
	onSubmit,
	disabledDay,
}: IOperationWindowRulesDuplicateFormProps) => {
	const { onClose } = useModal();

	const [selectedDays, setSelectedDays] = useState<string[]>([]);
	const [weekDays, setWeekDays] = useState<TRequiredSelectOption<string, IIsChecked>[]>(operationRulesWeekOptions);

	const handleSubmit = useCallback(() => {
		if (selectedDays.length > 0) {
			onSubmit(selectedDays);
			onClose();
		}
	}, [selectedDays, onSubmit, onClose]);

	return (
		<div className={styles.wrapper}>
			<span className={styles.note}>
				Note: This will replace any existing time intervals for the selected day(s)
			</span>
			<div className={styles.weekWrapper}>
				{weekDays.map((option) => {
					const onChange = (value: boolean) => {
						setWeekDays((prev) =>
							prev.map((day) =>
								day.value === option.value ? { ...day, isChecked: value } : day,
							),
						);

						setSelectedDays((prev) => value
							? [...prev, option.value]
							: prev.filter((day) => day !== option.value),
						);
					};

					const isDuplicateFrom = disabledDay?.weekDay.name === option.value;

					return (
						<Checkbox
							key={option.value}
							checked={option.isChecked || isDuplicateFrom}
							disabled={isDuplicateFrom}
							label={option.label?.toString() || ''}
							name={option.value}
							onChange={onChange}
						/>
					);
				})}
			</div>
			<SubmissionButtons
				disabledPositive={!selectedDays.length}
				negativeHandler={onClose}
				positiveHandler={handleSubmit}
				positiveLabel='Proceed'
			/>
		</div>
	);
};

export default OperationWindowRulesDuplicateForm;
